import { makeStyles } from "@material-ui/core/styles";
import { isiOS, isWeb } from "../../../lib/utils/utility";
import { fontClasses } from "../../../lib/fontStyles";

const useMobileStyles = makeStyles((theme) => ({
  energyModePopupContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "start",
    padding: "20px 16px",
    width: isWeb() ? "612px" : "auto",
    height: isWeb() ? "330px" : "auto",
  },
  energyModeIconContainer: {
    padding: isWeb() ? "25px 0 32px" : "15px 0 25px",
  },
  energyModeDescContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    textAlign: "center",
    ...fontClasses.title4,
    fontSize: isWeb() ? "16px" : "14px",
  },
  energyModeActionContainer: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    marginTop: isWeb() ? "32px" : "20px",
    gap: "8px",
  },
  positiveActionButton: {
    background: `${theme.palette.tertiary.provisionEnableButton} !important`,
    color: '#fff !important',
    textAlign:'center',
    width:'100%',
    padding: isWeb() ? "16px" : '12px',
    textTransform:'none',
    borderRadius: '8px',
    ...fontClasses.title4,
    fontSize: isWeb() ? "16px" : "14px",
  },
  negativeActionButton: {
    background: `transparent !important`,
    color: `${theme.palette.tertiary.provisionEnableButton} !important`,
    border: `1px solid ${theme.palette.tertiary.provisionEnableButton} !important`,
    textAlign:'center',
    width:'100%',
    padding: isWeb() ? "16px" : '12px',
    textTransform:'none',
    borderRadius: '8px',
    ...fontClasses.title4,
    fontSize: isWeb() ? "16px" : "14px",
  },
}));

export { useMobileStyles };
